import { render, staticRenderFns } from "./PlanificacionFormModal.vue?vue&type=template&id=0c071256&scoped=true"
import script from "./PlanificacionFormModal.vue?vue&type=script&lang=js"
export * from "./PlanificacionFormModal.vue?vue&type=script&lang=js"
import style0 from "./PlanificacionFormModal.vue?vue&type=style&index=0&id=0c071256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c071256",
  null
  
)

export default component.exports